// hooks/useSinisterFilters.ts
import { format, subDays, startOfMonth, endOfMonth } from "date-fns";
import { resolveDatesFromData } from "../helpers/resolveDatesFromData";

export function useSinisterFilters(searchParams: URLSearchParams, defaultStatus = "open") {
	const data = searchParams.get("data") || "mes";
	const isPeriodo = data === "periodo";

	const resolved = isPeriodo
		? {
				dataIni: searchParams.get("dataini") || "",
				dataFim: searchParams.get("datafim") || "",
		  }
		: resolveDatesFromData(data);

	const filters = {
		limit: Number(searchParams.get("limit")) || 10,
		selectedIdManager: searchParams.get("managerId") || "",
		selectedIdClient: searchParams.get("clientFilter") || "",
		createdFrom: searchParams.get("origem") || "",
		busyImobile: searchParams.get("imovel") || "Todos",
		typePeriod: searchParams.get("typePeriod") || "criacao",
		data,
		dataIni: resolved.dataIni,
		dataFim: resolved.dataFim,
		filterField: searchParams.get("typeField") || "documento",
		textSearch: searchParams.get("busca") || "",
		isSketch: Number(searchParams.get("sketch")) || 0,
		isLMI: Number(searchParams.get("lmiSaldo")) || 0,
		nameManager: searchParams.get("nameManager") || "",
		nameClient: searchParams.get("nameClient") || "",
		statusSinister: (searchParams.get("status") || defaultStatus).split(","),
		caseStatus: searchParams.get("caseStatus") || "Todos",
		// Responsável pela ATUAÇÃO DE COBRANÇA (setor cobrança/jurídico) — só usado no módulo de
		// Cobrança/Jurídico, ver PR-08-cobranca-responsavel-por-setor-frontend.md.
		selectedIdResponsible: searchParams.get("collectionResponsibleId") || "",
	};

	return filters;
}
